import { render, staticRenderFns } from "./rmHsnp.vue?vue&type=template&id=5dc88684"
import script from "./rmHsnp.vue?vue&type=script&lang=js"
export * from "./rmHsnp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports